import React from 'react';
import TrackRecord from './TrackRecord';

export default function HistoricalFund({
  sectionsConfig = [],
  fundData,
  fundKey,
}) {
  const sectionTitle =
    sectionsConfig.find(
      (section) => section.key === 'historical_fund_track_record'
    )?.title || 'Historical Fund Track Record';

  const aiProvidedData =
    fundData?.fund_data_in_json?.['ai-provided-data']?.[0] || null;

  return (
    <>
      <div className="fund-wrap-web m-2 mt-2 p-3">
        <p className="web-header">{sectionTitle}</p>
      </div>

      <div className="fund-wrap-content m-2 mt-2 p-3">
        <div className="d-flex justify-content-between align-items-center">
          <div className="recomandation-content">
            <TrackRecord fundData={aiProvidedData} fundkey={fundKey} />
          </div>
        </div>
      </div>
    </>
  );
}
